var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadMetaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59803 20.6033C6.21674 20.6033 5.09699 19.4836 5.09699 18.1023V15.1011C5.09699 14.4377 4.83349 13.8016 4.36445 13.3326C3.89541 12.8635 3.25926 12.6 2.59595 12.6C3.25926 12.6 3.89541 12.3365 4.36445 11.8675C4.83349 11.3984 5.09699 10.7623 5.09699 10.099V7.09772C5.09699 5.71643 6.21674 4.59668 7.59803 4.59668",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6023 4.59668C18.9836 4.59668 20.1033 5.71643 20.1033 7.09772V10.099C20.1033 11.4803 21.2231 12.6 22.6044 12.6C21.2231 12.6 20.1033 13.7198 20.1033 15.1011V18.1023C20.1033 19.4836 18.9836 20.6033 17.6023 20.6033",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27386 12.682C9.27386 12.6544 9.25147 12.632 9.22384 12.632C9.19622 12.632 9.17382 12.6544 9.17382 12.682C9.17382 12.7097 9.19622 12.7321 9.22384 12.7321C9.25147 12.7321 9.27386 12.7097 9.27386 12.682",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6503 12.673C12.6503 12.6454 12.6279 12.623 12.6003 12.623C12.5727 12.623 12.5503 12.6454 12.5503 12.673C12.5503 12.7007 12.5727 12.7231 12.6003 12.7231C12.6279 12.7231 12.6503 12.7007 12.6503 12.673",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6515 12.673C15.6515 12.6454 15.6292 12.623 15.6015 12.623C15.5739 12.623 15.5515 12.6454 15.5515 12.673C15.5515 12.7007 15.5739 12.7231 15.6015 12.7231C15.6292 12.7231 15.6515 12.7007 15.6515 12.673",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMetaIcon);
export default __webpack_public_path__ + "static/media/download-meta-icon.b30da1006a20f9ba526b2ca632c249c7.svg";
export { ForwardRef as ReactComponent };